import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem
import qs from 'qs'

// 获取申领单列表
export function getApplyList(data) {
    return request({
        url: serviceName + `/apply_list`,
        method: 'post',
        data: data
    })
}


// 新增申领单
export function addApply(data) {
    return request({
        url: serviceName + `/add_apply_use`,
        method: 'post',
        data: data
    })
}

// 删除申领单
export function deleteApply(data) {
    return request({
        url: serviceName + `/delete_apply_use`,
        method: 'post',
        data: data
    })
}

// 根据申领单号查询货物明细
export function queryApplyUse(data) {
    return request({
        url: serviceName + `/query_apply_use`,
        method: 'post',
        data: data
    })
}

// 申领单信息修改
export function updateApplyUse(data) {
    return request({
        url: serviceName + `/update_apply_use`,
        method: 'post',
        data: data
    })
}

// 申领单货物明细变更 
export function updateApplyGoods(data) {
    return request({
        url: serviceName + `/update_apply_goods`,
        method: 'post',
        data: data
    })
}

// 申领单货物明细变更 
export function updateXzRequestGoods(data) {
    return request({
        url: serviceName + `/update_xz_request_goods`,
        method: 'post',
        data: data
    })
}

// 申领单货物明细删除 
export function deleteApplyGoods(data) {
    return request({
        url: serviceName + `/delete_apply_goods`,
        method: 'post',
        data: data
    })
}

// 请购单货物明细删除 
export function deleteRequestGoods(data) {
    return request({
        url: serviceName + `/delete_xz_request_goods`,
        method: 'post',
        data: data
    })
}

// 行政申领已审批与待审批记录(多条件查询)
export function getApprovedList(data) {
    return request({
        url: serviceName + `/apply_approved_list` + '?' + qs.stringify(data),
        method: 'post',
        data: data
    })
}

// 行政申领审批
export function applyApprovalReject(data) {
    return request({
        url: serviceName + `/apply_approve_reject`,
        method: 'post',
        data: data
    })
}


// 申领单新增申领货物明细
export function addApplyGoodsList(data) {
    return request({
        url: serviceName + `/add_apply_goods_list`,
        method: 'post',
        data: data
    })
}

// 申领单新增请购货物明细
export function addXzRequestGoodsList(data) {
    return request({
        url: serviceName + `/add_xz_request_goods_list`,
        method: 'post',
        data: data
    })
}

// 请购货物明细列表
export function getXzRequestGoodsList(data) {
    return request({
        url: serviceName + `/xz_request_goods_list`,
        method: 'post',
        data: data
    })
}

// 请购货物明细列表
export function getXzYcgGoodsList(data) {
    return request({
        url: serviceName + `/xz_ycg_goods_list`,
        method: 'post',
        data: data
    })
}

// 申领单出库
export function addOutStore(data) {
    return request({
        url: serviceName + `/add_out_store`,
        method: 'post',
        data: data
    })
}

// 充值卡消费
export function addOutStoreCard(data) {
    return request({
        url: serviceName + `/add_out_store_card`,
        method: 'post',
        data: data
    })
}

// 充值卡消费记录修改
export function updateOutStoreCard(data) {
    return request({
        url: serviceName + `/update_out_store_card`,
        method: 'post',
        data: data
    })
}

